import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { Box, Hidden, lighten, Popover, Typography } from '@mui/material';
import { SecondaryButton } from '../../../../components/DesignSystem';
import ThemeToggle from '../../../../components/DesignSystem/ThemeToggle';

const UserBoxButton = styled(SecondaryButton)(
  ({ theme }) => `
    padding-left: ${theme.spacing(1)};
    padding-right: ${theme.spacing(1)};
    border: none;
    background: transparent;
    color: ${theme.palette.text.primary};
    
    &:hover {
      background: var(--primary-10, rgba(0,0,0,0.04));
      border: none;
    }
  `
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
    background: ${theme.colors.alpha.black[5]};
    padding: ${theme.spacing(2)};
  `
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
    text-align: left;
    padding-left: ${theme.spacing(1)};
  `
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
    font-weight: ${theme.typography.fontWeightBold};
    color: ${theme.palette.secondary.main};
    display: block;
  `
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
    color: ${lighten(theme.palette.secondary.main, 1)}
  `
);

function HeaderUserbox() {
  const user = {
    name: localStorage.getItem("username"),
  };

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <PersonIcon/>
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.company}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
        <Box sx={{ ml: 1 }}>
          <ThemeToggle />
        </Box>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex"/>
        <Box sx={{ m: 1 }}>
          <SecondaryButton 
            fullWidth 
            component={NavLink}
            to="/Login"
            startIcon={<LockOpenTwoToneIcon />}
          >
            Sair
          </SecondaryButton>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
